'use strict'

/**
 * @module stickyNav
 * @external lodash/throttle
 * @external lodash/debounce
 * @requires lodash/throttle
 * @requires lodash/debounce
 */

const CLASS_ACTIV = 'activ'
const CLASS_STICKY = 'sticky'

const SELECTOR_HEADER = '.cf-header'
const SELECTOR_STICKY_NAV = '.label-services'
const SELECTOR_STICKY_CONTAINER = '.top-services'
const SELECTOR_CLASS_ACTIV = `.${ CLASS_ACTIV }`

import { throttle } from 'lodash'

export default {
  /**
   * @description Initialise stickyNav
   * @returns {undefined}
   */
  init() {
    const stickyNav = document.querySelector(SELECTOR_STICKY_NAV)
    if (stickyNav) {
      stickyNav.style.width = window.getComputedStyle(stickyNav).width
    }

    this.headerHeight = document.querySelector(SELECTOR_HEADER).offsetHeight
    this.bind()
    this.checkHash()
  },

  /**
   * @description Bind events on stickyNav elements
   * @returns {undefined}
   */
  bind() {
    document.querySelectorAll(`${SELECTOR_STICKY_NAV} a`)
            .bindEvent('click', this.toggleStickyNavLinks)
    window.addEventListener('scroll', throttle(this.checkStickyNav.bind(this), 50))
  },

  /**
   * @description if hash defined on load, update nav, nav links and scroll
   * @returns {undefined}
   */
  checkHash() {
    const link = document.querySelector(`${SELECTOR_STICKY_NAV} [href="${location.hash}"]`)
    if (location.hash && link) {
      this.toggleStickyNavLinks({
        currentTarget: link
      })
      this.checkStickyNav()
    }
  },

  /**
   * @description Remove CLASS_ACTIV from links and add it on link passed as parameter
   * @params {event} e MouseEvent
   * @returns {undefined}
   */
  toggleStickyNavLinks(e) {
    const current = e.currentTarget
    if (current.classList.contains(CLASS_ACTIV)) {
      return
    }
    current.closest('ul').querySelector(SELECTOR_CLASS_ACTIV).classList.remove(CLASS_ACTIV)
    current.classList.add(CLASS_ACTIV)
  },

  /**
   * @description Check if CLASS_STICKY should be added or removed from SELECTOR_STICKY_CONTAINER
   * @returns {undefined}
   */
  checkStickyNav() {
    const stickyContainer = document.querySelector(SELECTOR_STICKY_CONTAINER)

    if (stickyContainer.getBoundingClientRect().top <= this.headerHeight) {
      if (!stickyContainer.classList.contains(CLASS_STICKY)) {
        stickyContainer.classList.add(CLASS_STICKY)
      }
    } else {
      stickyContainer.classList.remove(CLASS_STICKY)
    }
  }
}



// WEBPACK FOOTER //
// ./src/apps/Front/private/js/components/stickyNav.js